import React, { useEffect } from "react";
import { Typography } from "e100-react-components";
import { useReverseGeocode } from "entities/cars";
import LoadingContent from "components/LoadingContent";
import { useStyles } from "./styles";

interface LocationPositionProps {
  latitude: number;
  longitude: number;
}

const TEXT_STUB = "ulica Pory 78, 02-757 Mokotów, Poland";

export const LocationPosition = ({
  latitude,
  longitude,
}: LocationPositionProps) => {
  const classes = useStyles();
  const { address, isLoading, reverseGeocode } = useReverseGeocode();

  useEffect(() => {
    reverseGeocode({
      latitude,
      longitude,
    });
  }, [latitude, longitude, reverseGeocode]);

  return (
    <LoadingContent isLoading={isLoading}>
      <Typography
        variant="subtitle2"
        color="textSecondary"
        classes={{
          root: classes.addressContainer,
        }}
      >
        {address ?? TEXT_STUB}
      </Typography>
    </LoadingContent>
  );
};
